import { FilterSelect, SearchField } from '@/modules/common/components';
import { OptionType } from '@/modules/common/types';
import { ChangeTypes } from '@/modules/events/hooks';

import {
  EventParticipantStatus,
  participantStatusOptions,
} from '../../../../constants';

interface TableFiltersProps {
  types: OptionType[];
  filters: Record<string, string>;
  onFilters: (value: Record<string, string>) => void;
}

export function ParticipantsTableFilters({
  types,
  filters,
  onFilters,
}: TableFiltersProps) {
  return (
    <div className="flex gap-4 mr-auto">
      <div className="flex-1">
        <FilterSelect
          options={types}
          label="Type"
          value={filters.participantTypeId}
          onChange={(value) => onFilters({ participantTypeId: value })}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={participantStatusOptions}
          label="Status"
          value={filters.participantStatus}
          onChange={(value: EventParticipantStatus) =>
            onFilters({ participantStatus: value })
          }
        />
      </div>
    </div>
  );
}
